import { createTypes, actionCreator } from 'redux-action-creator';
import { parseJSON, handleNetworkError, getCookie } from '../../utils'
import { questionnaires } from './reducers';


export const questionnairesTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS','REQUEST_TO_PDF','RECEIVE_TO_PDF'], 'QUESTIONNAIRES');
export const tokenTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS'], 'QUESTIONNAIRES_TOKEN');
export const collectAnswersTypes = createTypes(['SET_ANSWER', 'EXPORT_ANSWERED_QUESTIONS', 'DELETE_ANSWER', 'RECEIVE', 'ERROR'], 'COLLECT_ADDITIONAL_ANSWERS');
export const myPagesQuestionnaireTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS'], 'MY_PAGES_QUESTIONNAIRE');



export const setQuestionAnswer = (key, value, customerId, questionnaireId) => {
    return {
        type: collectAnswersTypes.SET_ANSWER,
        key: key,
        value: value,
        customerId: customerId,
		questionnaireId: questionnaireId
    };
};

export const removeDataFromArray = (key, index, customerId, questionnaireId) => {
    return {
        type: collectAnswersTypes.DELETE_ANSWER,
        key: key,
        index: index,
        customerId: customerId,
        questionnaireId: questionnaireId
    };
};

export const requestQuestionnaires = () => {
    return {
        type: questionnairesTypes.REQUEST,
    };
};

export const receiveQuestionnaires = (response) => {
    function clean(obj) {
        // if an element/object has type==item and prop value we want to set obj = obj.value
        if (Array.isArray(obj)) {
            return obj.map(item => clean(item));
        } else if (typeof obj === "object" && obj !== null && Object.keys(obj).length > 0) {
            if (obj.type && obj.type==='item' && obj.value) {
                obj = obj.value;
            }
            for (let key in obj) {
                obj[key] = clean(obj[key]);
            }
        }
        return obj;
    }
    return {
        type: questionnairesTypes.RECEIVE,
        data: clean(response),
    };
};

export const receiveQuestionnairesError = (response) => {
    return {
        type: questionnairesTypes.ERROR,
        error: response,
    };
};

// Get list of questionnaires to choose from
export const getQuestionnaires = () => {
    return dispatch => {

        let apiUrl = `/api/v1/questionnaires`

        dispatch(requestQuestionnaires());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }

        return fetch(apiUrl, {
			// method: 'GET',
            headers: headers,
            credentials: 'include',
        })
        .then(parseJSON)
        .then(response => {
            try {
                dispatch(receiveQuestionnaires(response));
            } catch (e) {
                dispatch(receiveQuestionnairesError(response));
            }
        })
        .catch(handleNetworkError);
    };
};


export const requestToken = () => {
    return {
        type: tokenTypes.REQUEST,
    };
};

export const receiveToken = (response) => {
    return {
        type: tokenTypes.RECEIVE,
        data: response,
    };
};

export const receiveTokenError = (response) => {
    return {
        type: tokenTypes.ERROR,
        error: response,
    };
};



// Send list of questionnaires to be answered by client, get token
export const getQuestionListToken = (data) => {
	return dispatch => {

        let apiUrl = `/api/v1/questionnaireslist/`

        dispatch(requestToken());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
			'X-CSRFToken': getCookie("csrftoken"),
        }

        return fetch(apiUrl, {
			method: 'POST',
            headers: headers,
            credentials: 'include',
			body: JSON.stringify(data)
        })
        .then(parseJSON)
        .then(response => {
            try {
                dispatch(receiveToken(response));
            } catch (e) {
                dispatch(receiveTokenError(response));
            }
        })
        .catch(handleNetworkError);
    };
};

// Get the full questionnaires to answer, previously selected by agent
export const getQuestionnairesToAnswer = (questionlists) => {
	return dispatch => {

        // let apiUrl = `/additionalquestions/`
		// let apiUrl = `/api/v1/contract/${questionlists}/`
		let apiUrl = `/api/v1/additionalquestions/${questionlists}/`

        dispatch(requestQuestionnaires());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
			// 'X-CSRFToken': getCookie("csrftoken"),
        }

        return fetch(apiUrl, {
			// method: 'POST',
            headers: headers,
            credentials: 'include',
			// body: JSON.stringify(data)
        })
        .then(parseJSON)
        .then(response => {
            try {
                dispatch(receiveQuestionnaires(response));
            } catch (e) {
                dispatch(receiveQuestionnairesError(response));
            }
        })
        .catch(handleNetworkError);
    };
};

export const exportAnswers = () => {
    return {
        type: collectAnswersTypes.EXPORT_ANSWERED_QUESTIONS,
    };
};

export const receiveAnswers = (response) => {
    return {
        type: collectAnswersTypes.RECEIVE,
        data: response
    };
};

export const receiveAnswersError = (response) => {
    return {
        type: collectAnswersTypes.ERROR,
        error: response,
    };
};

// Get the full questionnaires to answer, previously selected by agent
export const exportQuestionnaireAnswers = (id, data, generatePdf = false) => {
	return dispatch => {

		let apiUrl = `/api/v1/questionnaireslist/${id}/`+(generatePdf?'?generatePdf=true':'');

        dispatch(exportAnswers());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
			'X-CSRFToken': getCookie("csrftoken"),
        }

        return fetch(apiUrl, {
			method: 'PUT',
            headers: headers,
            credentials: 'include',
            contentType: 'application/json',
			body: JSON.stringify(data)
        })
        .then(parseJSON)
        .then(response => {
            try {
                dispatch(receiveAnswers(response));
            } catch (e) {
                // dispatch(receiveQuestionnairesError(response));
                console.log("ERROR! ", e)
            }
            return response;
        })
        .catch(handleNetworkError);
    };
};


// Client side requests
export const requestQuestionnairesMyPages = () => {
    return {
        type: myPagesQuestionnaireTypes.REQUEST,
    };
};

export const receiveQuestionnairesMyPages = (response) => {
    return {
        type: myPagesQuestionnaireTypes.RECEIVE,
        data: response,
    };
};



export const fetchQuestionnairesMyPages = (questionlists) => {
	return dispatch => {

		let apiUrl = `/api/v1/mypagesquestionnaires/`

        dispatch(requestQuestionnairesMyPages());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
			// 'X-CSRFToken': getCookie("csrftoken"),
        }

        return fetch(apiUrl, {
			// method: 'POST',
            headers: headers,
            credentials: 'include',
			// body: JSON.stringify(data)
        })
        .then(parseJSON)
        .then(response => {
            try {
                dispatch(receiveQuestionnaires(response));
            } catch (e) {
                dispatch(receiveQuestionnairesError(response));
            }
        })
        .catch(handleNetworkError);
    };
};



export const requestAnsweredQuestionnaires = () => {
    return {
        type: questionnairesTypes.REQUEST_TO_PDF
    };

}



export const recieveAnsweredQuestionnaires = (response) => {
    return {
        type: questionnairesTypes.RECEIVE_TO_PDF,
        data: response,
    };

}
